/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import styled from 'styled-components';
import { DropDownItem, DropDownMenu } from '../DropDownMenu';

interface IProps {
  onExportPhoto: (backgroundColor?: string) => void;
}

const PhotoExportMenu = (props: IProps): React.ReactElement => {
  return (
    <GraphMenuWrapper>
      <DropDownMenu icon='photo_camera'>
        <DropDownItem
          target='#export-with-background'
          title='Export w/ Background'
          onClick={props.onExportPhoto.bind(
            null,
            window
              .getComputedStyle(document.documentElement)
              .getPropertyValue('--color-background')
          )}
        />
        <DropDownItem
          target='#export-with-background'
          title='Export w/ Transparent Background'
          onClick={props.onExportPhoto.bind(null, 'transparent')}
        />
      </DropDownMenu>
    </GraphMenuWrapper>
  );
};

export { PhotoExportMenu };

const GraphMenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
